<template>
  <div class="lab_wrapper">
    <div class="title">
      이미지 업로드
      <div class="desc"></div>
    </div>
    <b-container class="lab_container">
      <div class="editor">
        <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
          <div class="menubar">
            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.bold() }"
              @click="commands.bold"
            >
              <div class="h6 mb-0">
                <b-icon icon="type-bold" variant="success"></b-icon>
              </div>
            </button>

            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.italic() }"
              @click="commands.italic"
            >
              <div class="h6 mb-0">
                <b-icon icon="type-italic" variant="success"></b-icon>
              </div>
            </button>

            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.strike() }"
              @click="commands.strike"
            >
              <div class="h6 mb-0">
                <b-icon icon="type-strikethrough" variant="success"></b-icon>
              </div>
            </button>

            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.underline() }"
              @click="commands.underline"
            >
              <div class="h6 mb-0">
                <b-icon icon="type-underline" variant="success"></b-icon>
              </div>
            </button>

            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.bullet_list() }"
              @click="commands.bullet_list"
            >
              <div class="h6 mb-0">
                <b-icon icon="list-ul" variant="success"></b-icon>
              </div>
            </button>

            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.ordered_list() }"
              @click="commands.ordered_list"
            >
              <div class="h6 mb-0">
                <b-icon icon="list-ol" variant="success"></b-icon>
              </div>
            </button>

            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.blockquote() }"
              @click="commands.blockquote"
            >
              <div class="h6 mb-0">
                <b-icon icon="blockquote-left" variant="success"></b-icon>
              </div>
            </button>

            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.hlight({ flag: 1 }) }"
              @click="commands.hlight({ flag: 1 })"
            >
              <div class="h6 mb-0 btnhigh">PEN</div>
            </button>

            <button class="menubar__button" @click="commands.horizontal_rule">
              <div class="h6 mb-0">
                <div class="h6 mb-0 btnhigh">LINE</div>
              </div>
            </button>

            <button
              class="menubar__button"
              :class="{
                'is-active': isActive.alignnode({ textAlign: 'left' }),
              }"
              @click="commands.alignnode({ textAlign: 'left' })"
            >
              <div class="h6 mb-0">
                <div class="h6 mb-0 btnhigh">AL</div>
              </div>
            </button>

            <button
              class="menubar__button"
              :class="{
                'is-active': isActive.alignnode({ textAlign: 'center' }),
              }"
              @click="commands.alignnode({ textAlign: 'center' })"
            >
              <div class="h6 mb-0">
                <div class="h6 mb-0 btnhigh">AC</div>
              </div>
            </button>

            <button
              class="menubar__button"
              :class="{
                'is-active': isActive.alignnode({ textAlign: 'right' }),
              }"
              @click="commands.alignnode({ textAlign: 'right' })"
            >
              <div class="h6 mb-0">
                <div class="h6 mb-0 btnhigh">AR</div>
              </div>
            </button>
          </div>
        </editor-menu-bar>

        <editor-content class="editor__content" :editor="editor" />
      </div>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import Icon from "@/components/Icon";
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import Image from "./Image";
import NR from "./NewRuler";
import HLight from "./HLight";
import AlignPara from "./AlignPara";
import AlignNode from "./AlignNode";
import Box from "./Box.js";
import PapeList from "./PapeList.js";
import PapeItem from "./PapeItem.js";
import AWS from "aws-sdk";
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  OrderedList,
  HorizontalRule,
  BulletList,
  ListItem,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
} from "tiptap-extensions";

function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

async function upload(file) {
  AWS.config.update({
    region: "ap-northeast-2",
    credentials: new AWS.CognitoIdentityCredentials({
      IdentityPoolId: "ap-northeast-2:dc9b0c57-3ee5-47da-9239-931dcf6da667",
    }),
  });

  var s3 = new AWS.S3({
    apiVersion: "2006-03-01",
    params: { Bucket: "com.cedu.csd" },
  });

  let resp = await s3
    .upload({
      Key: uuidv4() + file.name,
      ContentType: "image/png",
      Body: file,
      ACL: "public-read",
    })
    .promise();

  return resp.Location;
}

export default {
  components: {
    EditorContent,
    EditorMenuBar,
  },
  data() {
    return {
      editor: new Editor({
        disablePasteRules: true, // disable Markdown when pasting
        disableInputRules: false, // disable Markdown when typing
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new NR(),
          new ListItem(),
          new OrderedList(),
          new PapeItem(),
          new PapeList(),
          new HorizontalRule(),
          new Link(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new Image(null, null, upload),
          new Box(),
          new HLight(),
          new AlignPara(),
          new AlignNode(),
        ],
        content: ``,
        dropCursor: {
          color: "red",
          width: 2,
        },
        onInit: ({ state, view }) => {},
        onUpdate: ({ state, getHTML, getJSON, transaction }) => {},
      }),
    };
  },
};
</script>


<style lang="scss">
@import "@/styles/_variables.scss";

.title {
  font-size: 1.5em;
  color: $gray500;
  margin-bottom: 15px;
  .desc {
    font-size: 0.7em;
  }
}

.lab_wrapper {
  margin: 15px;
}
.lab_container {
  background: white;
  border-radius: 5px;
  box-shadow: 3px 3px 3px $gray400;
  padding-bottom: 30px;
}

ul[data-type="todo_list"] {
  padding-left: 0;
}
li[data-type="todo_item"] {
  display: flex;
  flex-direction: row;
}
.todo-checkbox {
  border: 2px solid $gray500;
  height: 0.9em;
  width: 0.9em;
  box-sizing: border-box;
  margin-right: 10px;
  margin-top: 0.3rem;
  user-select: none;
  -webkit-user-select: none;
  cursor: pointer;
  border-radius: 0.2em;
  background-color: transparent;
  transition: 0.4s background;
}
.todo-content {
  flex: 1;
  > p:last-of-type {
    margin-bottom: 0;
  }
  > ul[data-type="todo_list"] {
    margin: 0.5rem 0;
  }
}
li[data-done="true"] {
  > .todo-content {
    > p {
      text-decoration: line-through;
    }
  }
  > .todo-checkbox {
    background-color: $gray500;
  }
}
li[data-done="false"] {
  text-decoration: none;
}

.img_wrapper_inner {
  .up_image {
    // max-width: 600px;
  }
  .up_desc {
    opacity: 1;
    font-size: 0.9em;
    padding: 2px 0 2px 2px;
    color: red;
    font-weight: 700;
    cursor: pointer;
  }
}

.btnhigh {
  font-size: 0.8rem;
}
.flag1 {
  border: 2px solid red;
  padding: 2px;
}
</style>